import * as actions from 'reducer/actionTypes';

// initialState 초기값
const initialState = {
	apiCalling: false
};

export default function apiCalling(state = initialState, action){

	switch(action.type){
		/* fetch request */
		// login

		case actions.FETCH_CHECKIP_REQUEST:
			return{
				...state,
				apiCalling: true
			}

		case actions.FETCH_LOGIN_REQUEST:
			return{
				...state,
				apiCalling: true
			}
		
		case actions.FETCH_LOGOUT_REQUEST:
			return{
				...state,
				apiCalling: true
			}
			
		// account
		case actions.FETCH_I18N_LANGUAGE_REQUEST:
			return{
				...state,
				apiCalling: true
			}

		case actions.FETCH_GET_ACCOUNT_INFO_REQUEST:
			return{
				...state,
				apiCalling: true
			}

		case actions.FETCH_GET_ACCOUNT_LANGUAGE_REQUEST:
			return{
				...state,
				apiCalling: true
			}

		case actions.FETCH_SET_ACCOUNT_CHANGE_USERID_REQUEST:
			return{
				...state,
				apiCalling: true
			}

		case actions.FETCH_SET_ACCOUNT_CHANGE_PASSWORD_REQUEST:
			return{
				...state,
				apiCalling: true
			}
		
		// license
		case actions.FETCH_GET_LICENSE_INFO_REQUEST:
			return{
				...state,
				apiCalling: true
			}

		case actions.FETCH_SET_LICENSE_UPDATE_REQUEST:
			return{
				...state,
				apiCalling: true
			}

		// adapter
		case actions.FETCH_GET_ADAPTER_LIST_REQUEST:
			return{
				...state,
				apiCalling: true
			}
		
		case actions.FETCH_SET_ADAPTER_UNREGISTER_REQUEST:
			return{
				...state,
				apiCalling: true
			}
		
		case actions.FETCH_SET_ADAPTER_ENABLE_REQUEST:
			return{
				...state,
				apiCalling: true
			}
		
		// adapter Register
		case actions.FETCH_SET_ADAPTER_REGISTER_REQUEST:
			return{
				...state,
				apiCalling: true
			}

		// adapter setting
		case actions.FETCH_GET_ADAPTER_SETTING_REQUEST:
			return{
				...state,
				apiCalling: true
			}

		case actions.FETCH_SET_ADAPTER_STORAGE_REQUEST:
			return{
				...state,
				apiCalling: true
			}

		case actions.FETCH_SET_ADAPTER_PARAMS_REQUEST:
			return{
				...state,
				apiCalling: true
			}

		case actions.FETCH_SET_ADAPTER_ROOTPATH_REQUEST:
			return{
				...state,
				apiCalling: true
			}

		// stats
		case actions.FETCH_GET_STATS_SUMMARY_INFO_REQUEST:
			return{
				...state,
				apiCalling: true
			}
		
		case actions.FETCH_GET_SETTING_INFO_REQUEST:
			return{
				...state,
				apiCalling: true
			}

		/* default */
		case actions.CLEAR_API_CALL_STATUS:
			return{
				...state,
				apiCalling: false,
			}
			
		default:
			return state
	}
}
